import { FETCH_AI_TRANSACTIONS, CLEAN_AI_TRANSACTIONS } from '../actions/types';

const AI_TRANSACTIONS_DEFAULT_STATE = {};

const AiTransactionsReducer = (state = AI_TRANSACTIONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_TRANSACTIONS:
            return payload;

        case CLEAN_AI_TRANSACTIONS:
            return AI_TRANSACTIONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiTransactionsReducer;
